import React from 'react';
import {AgreementDialog} from './AgreementDialog';
import {MapStateToProps, connect} from 'react-redux';
import {getConductAgreement} from '../../selectors/eula.selectors';

interface OwnProps {
    open: boolean;
    onClose: () => void;
}
interface StateProps {
    body: string;
    title: string;
}
type Props = OwnProps & StateProps;

const ConductDialog: React.FunctionComponent<Props> = props => <AgreementDialog {...props} />;

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
    body: getConductAgreement(state).body,
    title: getConductAgreement(state).title
});

export default connect(mapStateToProps)(ConductDialog);
